<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            <div class="row">
              <div class="d-flex align-items-center">

                <div class="search-set " style="margin-top: 10px !important; margin-bottom: 0px !important;">
                  
                  <div class="search-input">
                      <a class="btn btn-searchset"><img src="@/assets/img/icons/search-white.svg"
                              alt="img" /></a>
                      <div id="DataTables_Table_0_filter" class="dataTables_filter">
                          <label>
                              <input type="search" class="form-control form-control-sm"
                                  placeholder="Search..." aria-controls="DataTables_Table_0"
                                  v-model="query" />
                          </label>
                      </div>
                  </div>
  
  
                    
                </div>
                <div class="wordset">
                    <ul>
                        <!-- <li class="" >
                            <router-link class=" d-flex flex-column justify-content-between  align-items-center " to="importschedule" style="margin-top: 15px !important; margin-bottom: 0px !important;"><vue-feather
                                    type="upload" class="text-success"></vue-feather> <span class="text-black">Import</span></router-link>
                        </li> -->

                        <li>
                            <div class="form-group" style="margin-top: 10px !important; margin-bottom: 0px !important;">
                                <div class="input-groupicon" style="z-index: 100;">
                                    <!-- <datepicker v-model="periode" class="picker" :editable="true"
                                        :clearable="false" @update:modelValue="index" /> -->
                                    <!-- <a class="addonset">
                                        <i class='bx bx-calendar'></i>
                                    </a> -->
                                    <DatePicker 
                                        v-model:value="periode" 
                                        type="date"
                                        range
                                        format="YYYY-MM-DD"
                                        value-type="format"
                                        :clearable="true"
                                        class="picker"
                                        style="width: 268px !important;" 
                                    />

                                    <!-- @change="onDateChange" -->
                                    
                                </div>
                            </div>
                        </li>

                        <li class="d-flex align-items-center gap-3">
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Generate"
                                @click="generateData"
                                class="d-flex flex-column justify-content-center  align-items-center mt-2 btn btn-primary p-1">
                                <i class='bx bx-refresh' style="font-size: 25px;"></i> 
                                <!-- <span
                                    class="text-black">
                                    generate
                                </span> -->
                            </a>

                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel"
                                @click="insert"
                                class="d-flex flex-column justify-content-center  align-items-center btn btn-primary p-1 mt-2"><img
                                    src="../../../assets/img/Import_fill.png" alt="img" width="25" /> 
                                    <!-- <span
                                    class="text-black">
                                    excel
                                </span> -->
                            </a>

                            

                        </li>
  
                        
                        
  
                    </ul>
                </div>

              </div>
              
              <div class="table-responsive mt-3" v-if="setting_break_button == '0'">
                <!-- <div v-if="loading" class="text-center py-4">
                    <a-spin tip="Please wait..." />
                </div> -->
                  <a-table :columns="columnsB" :data-source="filteredData" :loading="loading">
                      <template #bodyCell="{ column, record }">
                          <template v-if="column.key === 'no'">
                              <div class="productimgname">
                                  {{ record.no }}
                              </div>
                          </template>
                            <template v-else-if="column.key === 'action'">
                                <a href="javascript:void(0);" class="me-3" v-if="isanviz != ''" @click.prevent="openHistoryLog(record)" style="cursor:pointer; color:#637381; font-size: 20px;">
                                    <i class='bx bx-history'></i>
                                </a>

                                
                            </template>
                          
                      </template>
                  </a-table>
              </div>

              <div class="table-responsive mt-3" v-if="setting_break_button == '1'">
                  <a-table :columns="columnsA" :data-source="filteredData" :loading="loading">
                      <template #bodyCell="{ column, record }">
                          <template v-if="column.key === 'no'">
                              <div class="productimgname">
                                  {{ record.no }}
                              </div>
                          </template>
                         

  
                      </template>
                  </a-table>
              </div>
            </div>


          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>

    <!-- history modal -->
    <div class="modal fade" id="historyModal" ref="historyModal" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">History Log</h5>
                    <button type="button" class="close" @click="hideModal2('historyModal')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <table class="table table-responsive">
                        <thead>
                            <tr>
                                <td>Name</td>
                                <td>Employee ID</td>
                                <td>Check Date</td>
                                <td>Check Time</td>
                                <td>Check Type</td>
                                <td>Device Name</td>
                                <td>Device SN</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in logData" :key="index">
                                <td>{{ item.employee_name }}</td>
                                <td>{{ item.employee_workno }}</td>
                                <td>{{ item.check_date }}</td>
                                <td>{{ item.check_time }}</td>
                                <td>{{ item.check_type }}</td>
                                <td>{{ item.device_name }}</td>
                                <td>{{ item.device_serial_number }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="modal-footer d-flex justify-content-end">
                    
                    <!-- <button type="submit" class="btn  btn-danger">Delete</button> -->
                </div>
                <!-- <form @submit.prevent="delete2">
                </form> -->
            </div>
        </div>
    </div>

</template>
<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, AlertBottom, appendForm, timeout, selectedBranch, goPage } from "@/assets/js/function";
import { watch } from "vue";

import DatePicker from 'vue-datepicker-next'
import 'vue-datepicker-next/index.css'


export default {
  // components: {
  //   Form,
  //   Field,
  // },
  components: {
        DatePicker
        
  },

  name: "editemployee",
  data() {
    return {
      filter: true,
      title: "HR Daily Report",
      title1: "generate daily report",
      config: "",
      api: "",

      loading: false,
       // periode: new Date(),
      periode: [],

      data: [],
      columnsA: [
              {
                  title: "No",
                  dataIndex: "no",
                  key: "no",
                  align: "left",
                  sorter: {
                      compare: (a, b) => {
                          a = a.no.toLowerCase();
                          b = b.no.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Log",
                  key: "action",
                  align: "left",
                  sorter: false,
                  
              },
              
              
              {
                  title: "Employee ID",
                  dataIndex: "employee_id",
                  key: "employee_id",
                  align: "left",
                  sorter: {
                      compare: (a, b) => {
                          a = a.employee_id.toLowerCase();
                          b = b.employee_id.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },

              {
                  title: "Employee",
                  dataIndex: "nama",
                  key: "nama",
                  align: "left",
                  sorter: {
                      compare: (a, b) => {
                          a = a.nama.toLowerCase();
                          b = b.nama.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },

              {
                  title: "Date",
                  dataIndex: "tanggal",
                  key: "tanggal",
                  align: "left",
                  sorter: {
                      compare: (a, b) => {
                          a = a.tanggal.toLowerCase();
                          b = b.tanggal.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Attendance Type",
                  dataIndex: "jenis_kehadiran",
                  key: "jenis_kehadiran",
                  align: "left",
                  sorter: {
                      compare: (a, b) => {
                          a = a.jenis_kehadiran.toLowerCase();
                          b = b.jenis_kehadiran.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Clock In",
                  dataIndex: "jam_masuk",
                  key: "jam_masuk",
                  align: "center",
                  sorter: {
                      compare: (a, b) => {
                          a = a.jam_masuk.toLowerCase();
                          b = b.jam_masuk.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Clock Out",
                  dataIndex: "jam_pulang",
                  key: "jam_pulang",
                  align: "center",
                  sorter: {
                      compare: (a, b) => {
                          a = a.jam_pulang.toLowerCase();
                          b = b.jam_pulang.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Overtime Start",
                  dataIndex: "jam_mulai_lembur",
                  key: "jam_mulai_lembur",
                  align: "center",
                  sorter: {
                      compare: (a, b) => {
                          a = a.jam_mulai_lembur.toLowerCase();
                          b = b.jam_mulai_lembur.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },

              {
                  title: "Overtime End",
                  dataIndex: "jam_selesai_lembur",
                  key: "jam_selesai_lembur",
                  align: "center",
                  sorter: {
                      compare: (a, b) => {
                          a = a.jam_selesai_lembur.toLowerCase();
                          b = b.jam_selesai_lembur.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },

              // break in break out

              {
                  title: "Break In",
                  dataIndex: "jam_istirahat_masuk",
                  key: "jam_istirahat_masuk",
                  align: "center",
                  sorter: {
                      compare: (a, b) => {
                          a = a.jam_istirahat_masuk.toLowerCase();
                          b = b.jam_istirahat_masuk.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Break Out",
                  dataIndex: "jam_istirahat_keluar",
                  key: "jam_istirahat_keluar",
                  align: "center",
                  sorter: {
                      compare: (a, b) => {
                          a = a.jam_istirahat_keluar.toLowerCase();
                          b = b.jam_istirahat_keluar.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },

              // end of break in break out
              
              {
                  title: "Total Work Hours",
                  dataIndex: "selisih_jam_kerja",
                  key: "selisih_jam_kerja",
                  align: "center",
                  sorter: {
                      compare: (a, b) => {
                          a = a.selisih_jam_kerja.toLowerCase();
                          b = b.selisih_jam_kerja.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Total Overtime",
                  dataIndex: "selisih_jam_lembur",
                  key: "selisih_jam_lembur",
                  align: "center",
                  sorter: {
                      compare: (a, b) => {
                          a = a.selisih_jam_lembur.toLowerCase();
                          b = b.selisih_jam_lembur.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Minutes Late",
                  dataIndex: "menit_terlambat",
                  key: "menit_terlambat",
                  align: "center",
                  sorter: {
                      compare: (a, b) => {
                          a = a.menit_terlambat.toLowerCase();
                          b = b.menit_terlambat.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Notes",
                  dataIndex: "keterangan",
                  key: "keterangan",
                  
                  sorter: {
                      compare: (a, b) => {
                          a = a.keterangan.toLowerCase();
                          b = b.keterangan.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              
      ],

      columnsB: [
              {
                  title: "No",
                  dataIndex: "no",
                  key: "no",
                   align: "left",
                  sorter: {
                      compare: (a, b) => {
                          a = a.no.toLowerCase();
                          b = b.no.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              
              {
                  title: "Log",
                  key: "action",
                  align: "left",
                  sorter: false,
                  
              },
              {
                  title: "Employee ID",
                  dataIndex: "employee_id",
                  key: "employee_id",
                  align: "left",
                  sorter: {
                      compare: (a, b) => {
                          a = a.employee_id.toLowerCase();
                          b = b.employee_id.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Employee",
                  dataIndex: "nama",
                  key: "nama",
                  align: "left",
                  sorter: {
                      compare: (a, b) => {
                          a = a.nama.toLowerCase();
                          b = b.nama.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },

              {
                  title: "Date",
                  dataIndex: "tanggal",
                  key: "tanggal",
                  align: "left",
                  sorter: {
                      compare: (a, b) => {
                          a = a.tanggal.toLowerCase();
                          b = b.tanggal.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Attendance Type",
                  dataIndex: "jenis_kehadiran",
                  key: "jenis_kehadiran",
                  align: "left",
                  sorter: {
                      compare: (a, b) => {
                          a = a.jenis_kehadiran.toLowerCase();
                          b = b.jenis_kehadiran.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Clock In",
                  dataIndex: "jam_masuk",
                  key: "jam_masuk",
                  align: "center",
                  sorter: {
                      compare: (a, b) => {
                          a = a.jam_masuk.toLowerCase();
                          b = b.jam_masuk.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Clock Out",
                  dataIndex: "jam_pulang",
                  key: "jam_pulang",
                  align: "center",
                  sorter: {
                      compare: (a, b) => {
                          a = a.jam_pulang.toLowerCase();
                          b = b.jam_pulang.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Overtime Start",
                  dataIndex: "jam_mulai_lembur",
                  key: "jam_mulai_lembur",
                  align: "center",
                  sorter: {
                      compare: (a, b) => {
                          a = a.jam_mulai_lembur.toLowerCase();
                          b = b.jam_mulai_lembur.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },

              
              {
                  title: "Overtime End",
                  dataIndex: "jam_selesai_lembur",
                  key: "jam_selesai_lembur",
                  align: "center",
                  sorter: {
                      compare: (a, b) => {
                          a = a.jam_selesai_lembur.toLowerCase();
                          b = b.jam_selesai_lembur.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Total Work Hour",
                  dataIndex: "selisih_jam_kerja",
                  key: "selisih_jam_kerja",
                  align: "center",
                  sorter: {
                      compare: (a, b) => {
                          a = a.selisih_jam_kerja.toLowerCase();
                          b = b.selisih_jam_kerja.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Total Overtime",
                  dataIndex: "selisih_jam_lembur",
                  key: "selisih_jam_lembur",
                  align: "center",
                  sorter: {
                      compare: (a, b) => {
                          a = a.selisih_jam_lembur.toLowerCase();
                          b = b.selisih_jam_lembur.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Minutes Late",
                  dataIndex: "menit_terlambat",
                  key: "menit_terlambat",
                  align: "center",
                  sorter: {
                      compare: (a, b) => {
                          a = a.menit_terlambat.toLowerCase();
                          b = b.menit_terlambat.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Notes",
                  dataIndex: "keterangan",
                  key: "keterangan",
                  align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.keterangan.toLowerCase();
                          b = b.keterangan.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              
      ],

      //filter
      query: "",
      setting_break_button: "0",


      //data
      currentData: {
      },
      startDate: new Date,
      endDate: new Date,

      formatFilter: "EXCEL",
      FormatList: ["PDF", "EXCEL"],
    };
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 1200000,
    }
    
    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;

    localStorage.setItem('actionState', 'view')

    // Set default date range (1st to last day of current month)
    const storedStart = localStorage.getItem("startCutOff");
    const storedEnd = localStorage.getItem("EndCutOff");

    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth(); // zero-based
    
    // const start = new Date(year, month - 1, storedStart ? parseInt(storedStart) : 1);
    const startDay = storedStart ? parseInt(storedStart) : 1;
    const endDay = storedEnd ? parseInt(storedEnd) : 0;

    const start = new Date(year, month, startDay);

    let end;
    if (startDay === 1) {
        // If start is 1st → end is last day of same month
        end = new Date(year, month + 1, 0);
    } else {
        if (endDay > 0) {
            // If endDay <= startDay, it should be in the *next* month
            if (endDay <= startDay) {
            end = new Date(year, month + 1, endDay);
            } else {
            end = new Date(year, month, endDay);
            }
        } else {
            // fallback if storedEnd missing
            end = new Date(year, month + 1, 0);
        }
    }

    this.periode = [
      this.formatDateLocal(start),
      this.formatDateLocal(end),
    ];
  },

    mounted() {
        watch(selectedBranch, () => {
            this.index()
        }, { immediate: true })
    },

  computed: {
    filteredData() {
      // If no query entered, return all data
      if (this.query === '') {
        return this.data;
      }

      const lowerCaseQuery =  (this.query || '').toLowerCase();

      return this.data.filter(item => {
        return (
          (item.employee_id || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.nama || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.tanggal || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.jenis_kehadiran || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.jam_masuk || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.jam_mulai_lembur || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.jam_selesai_lembur || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.keterangan || '').toLowerCase().includes(lowerCaseQuery)
        );
      });
    }
  },

  methods: {

    formatDateLocal(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    generateData() {
        this.index()
    },

    showModal(modal_name) {
        
        const modal = this.$refs[modal_name];
        
        // Show modal
        modal.classList.add('show');
        modal.style.display = 'block';

        // Add backdrop manually
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        backdrop.setAttribute('data-modal-backdrop', modal_name); // optional attribute to identify
        document.body.appendChild(backdrop);

        // Prevent body scroll
        document.body.classList.add('modal-open');
    },

    hideModal2(modal_name) {
        const modal = this.$refs[modal_name];
        
        // Hide modal
        modal.classList.remove('show');
        modal.style.display = 'none';

        // Remove backdrop
        const backdrop = document.querySelector(`.modal-backdrop[data-modal-backdrop="${modal_name}"]`);
        if (backdrop) backdrop.remove();

        // Remove scroll lock
        document.body.classList.remove('modal-open');
    },

    async openHistoryLog(record) {
        this.loading = true;

        const formData = new FormData();
        appendForm(formData);

        formData.append("tanggal", record.tanggal_raw);
        //  if (this.periode && this.periode.length === 2) {
        //     const [startDate, endDate] = this.periode;
        //     formData.append("tanggal",  startDate);  // end date
        //     // formData.append("dto", endDate);  // start date
        // }
        formData.append("employee_id", record.employee_id);

        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }
        // return

        const api = base_url + '/v3/attendances/anviz_index';
        const res = await axios.post(api, formData, { timeout });
        const data = res.data;
        
        console.log(" History", data);
        
        if(data.status){
            const history = data.data.data_history

            this.logData = [];
            history.forEach((item, index) => {
                const item_prepare = {
                    ...item,
                    no: index + 1,
                    
                    };
                this.logData.push(item_prepare);
            });

            this.showModal('historyModal')

            this.loading = false;
            // console.log('tes seting break button', this.setting_break_button)
            
        }else {
            AlertPopup2("error", "", data.message, true, 1500);
        }
        
        
    },

    async insert() {
      
        let formData = new FormData();
        appendForm(formData)

        // Ensure periode has both start and end dates
        if (this.periode && this.periode.length === 2) {
            const [startDate, endDate] = this.periode;
            formData.append("dfrom",  startDate);  // end date
            formData.append("dto", endDate);  // start date
        }

        formData.append('query', this.query)

        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }
        // CloseLoading(); return;

        const api = base_url + '/v3/reports/daily_excel';
        const res = await axios.post(api, formData, { timeout });
        const data = res.data;
        // console.log('ini data overtime:', data)

        if(data.status){
                window.open(data.data.file_report, "_blank");
                
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

      
    },

    onDateChange(value) {
        this.periode = value;
        this.index();
    },

    async index() {
        this.loading = true;

        try{
            let formData = new FormData();
            appendForm(formData)
    
            // Ensure periode has both start and end dates
            if (this.periode && this.periode.length === 2) {
                const [startDate, endDate] = this.periode;
                formData.append("dfrom",  startDate);  // end date
                formData.append("dto", endDate);  // start date
            }
            
            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
            // CloseLoading(); return;
    
    
            const api = base_url + '/v3/reports/daily';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            const dailyReport = data.data.data_daily_report;
            console.log('ini data overtime:', data)
            
            if(data.status){
                this.data = [];
                dailyReport.forEach((item, index) => {
                    let item_prepare = { ...item, no: (index + 1), };
                    this.data.push(item_prepare);
                });
    
                localStorage.setItem('setting_break_button', JSON.stringify(data.data.setting_break_button));
                this.setting_break_button = data.data.setting_break_button;
                
                
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

        } catch (err) {
            console.error(err);
            AlertPopup2("error", "", "Something went wrong.", true, 1500);
        } finally {
            this.loading = false;
        }

       
    },

  },

};
</script>

